import React, { useState } from 'react';
import Dino from './Dino';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {IconPlayerPlayFilled, IconArrowUpRight, IconX, IconFileCv, IconBrandInstagram, IconMessage, IconUser, IconCode} from '@tabler/icons-react';
import image from './assets/arghya.jpg';
import music from './assets/music.mp4';
import { useSelector } from 'react-redux';

const BentoGrid = (props) => {
    const [Play, setPlay] = useState(false);
    const data = useSelector((state) => state.data.data);


    const togglePlay = () => {
        if(Play){
            setPlay(false);
        } else {
            setPlay(true);
        }
    }

    const revealFromLeft = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0 },
    };
    
    const revealFromRight = {
        hidden: { opacity: 0, x: 100 },
        visible: { opacity: 1, x: 0 },
    };
    
    const revealFromBottom = {
        hidden: { opacity: 0, y: 100 },
        visible: { opacity: 1, y: 0 },
    };

    const calculateYearsOfExperience = () => {
        const startDate = new Date('2022-11-01');
        const currentDate = new Date();
        const diffTime = Math.abs(currentDate - startDate);
        const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25);
        return Math.floor(diffYears);
    };

    const yearsOfExperience = calculateYearsOfExperience();


    return(
        <div className="bentogrid mt-28 mb-28 flex flex-col">
            <div className="flex flex-col">
                <div className="flex flex-1 sm:flex-col">
                <motion.div
                    className="flex-1"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.5 }}
                    variants={revealFromLeft}
                >
                    <Link to={"/projects"}>
                    <div className="bentobox flex flex-col justify-end p-5 relative group flex-1">
                        <div
                        style={{ background: "#363636" }}
                        className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                        >
                        <IconCode color='#ccc' />
                        </div>

                        <div className="bentotext">
                        <p className="font-bold">{`>./projects`}</p>
                        <p className="font-bold text-5xl mt-3">All <br /> Projects.</p>
                        <p className='text-sm mt-3 text-gray-300'>{`// Explore all my projects`}</p>
                        </div>
                    </div>
                    </Link>
                </motion.div>
                <motion.div
                    style={{flex: "1.5"}}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.5 }}
                    variants={revealFromRight}
                >
                    <Link to={data.highlightProject.link}>
                        <div className="bentobox flex flex-col justify-end p-5 relative group flex-1">
                            <div
                            style={{ background: "#363636" }}
                            className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                            >
                            <IconArrowUpRight color='#ccc' />
                            </div>

                            <div className="bentotext">
                            <p className="font-bold">{`>./project/01`}</p>
                            <p className="font-bold text-5xl mt-3">{data.highlightProject.title}.</p>
                            <p className='text-sm mt-3 text-gray-300'>{`// ${data.highlightProject.desc}`}</p>
                            <p className='text-sm mt-1 text-gray-300'>{`// ${data.highlightProject.tech}`}</p>
                            </div>
                        </div>
                    </Link>
                </motion.div>
                </div>

                <div className="flex flex-1 sm:flex-col">
                    {data.showcase && data.showcase.map((project, index) => (
                        <motion.div
                            key={index}
                            className="flex-1"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false }}
                            transition={{ duration: 0.5 }}
                            variants={index % 2 === 0 ? revealFromLeft : revealFromRight}
                        >
                            <Link to={project.link}>
                            <div className="bentobox flex flex-col justify-end p-5 relative group flex-1">
                                <div
                                style={{ background: "#363636" }}
                                className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                                >
                                <IconArrowUpRight color='#ccc' />
                                </div>

                                <div className="bentotext">
                                <p className="font-bold">{`>./project/0${index+2}`}</p>
                                <p className="font-bold text-5xl mt-3">{project.title}.</p>
                                <p className='text-sm mt-3 text-gray-300'>{`// ${project.desc}`}</p>
                                <p className='text-sm mt-1 text-gray-300'>{`// ${project.tech}`}</p>
                                </div>
                            </div>
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>

            <div className="flex flex-1 lg:flex-col-reverse">
                <motion.div
                style={{ flex: 1.75 }}
                className="flex flex-col"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.5 }}
                variants={revealFromLeft}
                >
                <div style={{ margin: '10px' }} className='flex-1 '>
                    <Link to={"/#contact"}>
                    <div style={{ margin: 0 }} className="bentobox flex flex-col p-5 justify-end h-full relative group flex-1">
                        <div
                        style={{ background: "#363636" }}
                        className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                        >
                        <IconMessage color='#ccc' />
                        </div>

                        <div className="bentotext">
                        <p className="font-bold">{`>./contact`}</p>
                        <p className="font-bold text-5xl mt-3">Lets <br /> Connect.</p>
                        <p className='text-sm mt-3 text-gray-300'>{`// Have a project in mind?`}</p>
                        <p className='text-sm mt-1 text-gray-300'>{`// Lets turn in into reality!`}</p>
                        </div>
                    </div>
                    </Link>
                </div>
                <div className="bentobox flex-1"><Dino /></div>
                </motion.div>
                <motion.div
                style={{ flex: 2.25 }}
                className="flex sm:flex-col"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.5 }}
                variants={revealFromBottom}
                >
                <div style={{ flex: 1.25 }} className="flex">
                    <div style={{ background: Play ? "#000" : "#1d1d1d" }} className="bentobox flex-1 relative group">
                    <div
                        onClick={togglePlay}
                        style={{ background: "#363636" }}
                        className={`playbutton z-10 absolute top-4 ${Play ? "left" : "right"}-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300`}
                    >
                        {Play ? <IconX color='#ccc' /> : <IconPlayerPlayFilled color='#ccc' />}
                    </div>
                    <Link target='_blank' to={data.meta.social.music}>
                        <div
                            style={{ background: "#363636" }}
                            className={`playbutton z-10 absolute right-4 ${Play ? "top" : "bottom"}-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity p-2 flex justify-center items-center rounded-xl duration-300`}
                        >
                            <IconArrowUpRight color='#ccc' />
                        </div>
                    </Link>
                    {!Play && (
                        <Link target='_blank' to={data.meta.social.instagram}>
                            <div
                                style={{ background: "#363636" }}
                                className="playbutton z-10 absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity p-2 flex justify-center items-center rounded-xl duration-300"
                            >
                                <IconBrandInstagram color='#ccc' /> <span className='ml-2'>ig.music</span>
                            </div>
                        </Link>
                    )}
                    {Play ? (
                        <video autoPlay controls src={music} className='h-full w-full'></video>
                    ) : (
                        <img className='w-full h-full' src={image} alt="" />
                    )}
                    </div>
                </div>
                <div className="flex-1 flex flex-col">
                    <motion.div
                    style={{ margin: '10px' }}
                    className='flex-1 '
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.5 }}
                    variants={revealFromRight}
                    >
                    <Link to={"/about"}>
                        <div style={{ margin: 0 }} className="bentobox flex flex-col p-5 justify-end h-full relative group flex-1">
                        <div
                            style={{ background: "#363636" }}
                            className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                        >
                            <IconUser color='#ccc' />
                        </div>

                        <div className="bentotext">
                            <p className="font-bold">{`>./about`}</p>
                            <p className="font-bold text-5xl mt-3">My <br /> Story.</p>
                            <p className='text-sm mt-3 text-gray-300'>{`// Readme.md`}</p>
                        </div>
                        </div>
                    </Link>
                    </motion.div>
                    <motion.div
                    style={{ margin: '10px' }}
                    className='flex-1 '
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.5 }}
                    variants={revealFromRight}
                    >
                    <Link to={data.meta.resume}>
                        <div style={{ margin: 0 }} className="bentobox flex flex-col p-5 justify-end h-full relative group flex-1">
                        <div
                            style={{ background: "#363636" }}
                            className="playbutton absolute top-4 right-4 opacity-0 group-hover:opacity-100 md:opacity-100 transition-opacity size-10 flex justify-center items-center rounded-xl duration-300"
                        >
                            <IconFileCv color='#ccc' />
                        </div>

                        <div className="bentotext">
                            <p className="font-bold">{`>./resume`}</p>
                            <p className="font-bold text-5xl mt-3">{yearsOfExperience}+ <br /> Years.</p>
                            <p className='text-sm mt-3 text-gray-300'>{`// My Experience`}</p>
                        </div>
                        </div>
                    </Link>
                    </motion.div>
                </div>
                </motion.div>
            </div>
        </div>
    );
}


export default BentoGrid;